<template>
  <div class="hello">
    <el-page-header class="page-header" @back="(onSubmit = true), fanhui()" content="审批步骤" >
      </el-page-header>
  <div class="Mmain">
    <nav>
      <span class="shij">
        <!-- <el-button @click="(onSubmit = true), fanhui()" icon="el-icon-back" style="margin-right: 2.0rem">
          返回
        </el-button> -->
        <el-button @click="(onSubmit = true), tianjia()" icon="el-icon-plus" type="primary">
          添加
        </el-button>
      </span>
    </nav>
    <el-table :data="tableData"  border style="width: 100%; margin-top: 2.0rem" height="600" v-infinite-scroll="load">
      <el-table-column prop="order_id" label="排序" style="width: 10%"></el-table-column>
      <el-table-column prop="user_name" label="审批人" style="width: 50%"></el-table-column>
      <el-table-column prop="flow_name" label="审批流名称" style="width: 50%"></el-table-column>

      <el-table-column prop="createtime" label="创建时间" style="width: 20%">
        <template slot-scope="scope">
          <div>{{ (scope.row.createtime * 1000) | formatDate }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="updatetime" label="更新时间" style="width: 50%">
        <template slot-scope="scope">
          <div>{{ (scope.row.createtime * 1000) | formatDate }}</div>
        </template>
      </el-table-column>

      <el-table-column label="操作" fixed="right" width="200">
        <template slot-scope="scope">
          <el-button @click="
            (onSubmitn = true),
            bianji(
              scope.row.id,
              scope.row.user_name,
              scope.row.userid,
              scope.row.order_id
            )
          " size="small" type="text">编辑</el-button>
          <el-button @click="handleClick(scope.row.id)" size="small" type="text" style="color:#f00000 !important">
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
    <el-dialog title="添加" center :visible.sync="onSubmit" width="25%">
      <!-- <div class="bule"></div> -->

      <el-form ref="form" :model="form" label-width="8.0rem">
        <el-form-item label="审批人" prop="name" style="width: 100">
          <div class="shenpi" @click="addContact">{{ name }}</div>
        </el-form-item>
        <el-form-item label="排序" prop="age">
          <el-input clearable style="width: 25.0rem" v-model="form.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit = false">取 消</el-button>
        <el-button type="primary" @click="numoo()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑" center :visible.sync="onSubmitn" width="25%">
      <el-form ref="form" :model="forms" label-width="8.0rem">
        <el-form-item label="审批人" prop="name">
          <!-- <el-select clearable v-model="value3" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.userid"
              :label="item.name"
              :value="item.userid"
            ></el-option>
          </el-select> -->
          <div class="shenpi" @click="addContact">{{ name }}</div>
        </el-form-item>
        <el-form-item label="排序" prop="age">
          <el-input clearable style="width: 25.0rem" v-model="forms.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitn = false">取 消</el-button>
        <el-button type="primary" @click="numoon()">确 定</el-button>
      </span>
    </el-dialog>
    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import rightPeople from '@/components/drawer/rightPeople';
export default {
  name: "monitoring",
  components: {
    rightPeople
  },
  data() {
    return {
      tableData: [],
      input2: "",
      onSubmit: false,
      onSubmitn: false,
      tableData_a: [],
      multipleSelection: [],
      value1: true,
      form: {
        name: "",
        none: "",
      },
      forms: {
        name: "",
        none: "",
      },
      ele: "",
      yeshu: 1,
      bianjile: "",
      id: {},
      value3: "",
      options: [],
      value: "",
      ids: "",
      checkbox: false,
      module: "",
      selectionDepartment: true,
      selectionName: true,
      name: "",
    };
  },
  mounted() {
    this.id = this.$route.query.tableData;
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.userTable();
    this.tianjia();
  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
  },
  methods: {
    fanhui() {
      this.$router.push("/register/user/flow");
    },
    //  页数
    load() {
      setTimeout(() => {
        this.yeshu += 1;
        this.axios
          .post(
            "/crm/Source/getSourceList",
            qs.stringify({
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              phone: this.tooken.phone,
              page: this.yeshu,
              name: this.input2,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }

            res.data.data.forEach((item) => {
              this.tableData.push(item);
            });
          })
          .catch(function (err) { });
      }, 2000);
    },
    userTable() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/ExamineStep/getList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            flow_id: this.id[0].id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) { });
    },
    rune() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/Source/getSourceList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.input2,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) { });
    },
    tianjia() {
      this.name = "";
      this.value = "";
      this.form.name = "";
    },

    handleSelectionChange(val) {
      this.yeshu = 1;
      this.multipleSelection = val;
    },
    bianji(e, o, n, p) {
      this.ids = e;
      this.name = o;
      this.value = n;
      this.forms.name = p;
    },
    // 修改
    numoon() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/ExamineStep/editStep",
          qs.stringify({
            id: this.ids,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            userid: this.value,
            flow_id: this.id[0].id,
            phone: this.tooken.phone,
            order_id: this.forms.name,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          if (res.data.code == 1) {
            this.onSubmitn = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmitn = true;
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    // 添加
    numoo() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/ExamineStep/addStep",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            userid: this.value,
            flow_id: this.id[0].id,
            phone: this.tooken.phone,
            order_id: this.form.name,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    // 移除
    handleClick(e, o) {
      this.yeshu = 1;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/ExamineStep/delStep",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                id: e,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.onSubmit = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.$message(res.data.msg);
                this.$message.error(res.data.msg);
              }
              this.userTable();
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.tableData_a = res.data.data;
            })
            .catch(function (err) { });
        })
        .catch(() => { });
    },
    addContact() {
      this.module = "getAddressBook";
      this.checkbox = false;
      this.isGroup = true;
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      this.value = person.userid;
      this.name = person.name;
    },
  },
};
</script>
<style scoped>
.hello {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  margin-top: -.4rem;
}

nav {
  width: 100%;
}
.shij {
  display: inline-block;
  margin-right: 4.0rem;
}
.shenpi {
  width: 25.0rem;
  height: 4.0rem;
  border: .1rem solid #dcdfe6;
  padding: 0 1.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.Mmain{
    width: 100%;
    padding: 3.0rem;
    background: #fff;
    border-radius: .8rem;
}
</style>
